export const EXPERIENCES_FETCH = 'EXPERIENCES_FETCH';
export const EXPERIENCES_FETCH_FAILURE = 'EXPERIENCES_FETCH_FAILURE';
export const EXPERIENCES_FETCH_SUCCESS = 'EXPERIENCES_FETCH_SUCCESS';
export const EXPERIENCE_COMPLETE = 'EXPERIENCE_COMPLETE';
export const EXPERIENCE_COMPLETE_FAILURE = 'EXPERIENCE_COMPLETE_FAILURE';
export const EXPERIENCE_COMPLETE_SUCCESS = 'EXPERIENCE_COMPLETE_SUCCESS';
